import {keepPreviousData, useQuery} from '@tanstack/react-query';
import {OrderHistory,QUERY_CACHE_KEYS} from '@chekin/core';
import {useChekinSDK} from '../../context/ChekinSDK';
import {useReservation} from '../../context/reservation';
import {API} from '@chekin/api';

const CACHE_TIME = 10_000;
const STALE_TIME = 10_000;

type UseOrderHistoryProps = {
  refetchOnWindowFocus?: boolean;
  enabled?: boolean;
};
function useOrderHistory({
  refetchOnWindowFocus = false,
  enabled = true,
}: UseOrderHistoryProps = {}) {
  const {isTokenValid} = useChekinSDK();
  const {reservationId} = useReservation();

  const {
    data: orderHistory,
    isLoading: isOrderHistoryLoading,
    isFetching: isOrderHistoryFetching,
  } = useQuery<OrderHistory>({
    queryKey: [QUERY_CACHE_KEYS.orderHistory, reservationId],
    queryFn: () => API.payments.getOrderHistory(`reservation_id=${reservationId}`),
    placeholderData: keepPreviousData,
    enabled: Boolean(reservationId && isTokenValid && enabled),
    refetchOnWindowFocus,
    gcTime: CACHE_TIME,
    staleTime: STALE_TIME,
  });

  return {
    orderHistory,
    isOrderHistoryLoading,
    isOrderHistoryFetching,
  };
}

export {useOrderHistory};
